import { useGetUserHasSubscriptionQuery } from '../../../../user_profile/userProfileSlice';
import roundedLogo from '../../../../common/assets/images/img_blue_fish.png';
import UserTicketSummary from '../../summaries/UserTicketSummary';
import MarketingBrandsCard from './MarketingBrandsCard';
import SBPlusAdvertCard from './SBPlusAdvertCard';
import React from 'react';
import { Button } from 'antd';
import { sendWidgetMessage } from '../../../../../utils/widgetUtils';
import '../../../assets/css/user_booking_success.css';
import UserBookingNewAccountCreationForm from './UserBookingNewAccountCreationForm';

function NewAccountCard({ token, userId, bookingId }) {
  return (
    <div
      className={'br20 txt-center overflow-hidden'}
      style={{ background: '#E9EFF3' }}
      id={'account-creation'}
    >
      <div className='uppercase gBold fs-21 pd-10 grey-100 sb-blue-bg-600'>
        Important Information
      </div>
      <div className={'pd-20 pd-left-30 pd-right-30'}>
        <UserBookingNewAccountCreationForm
          token={token}
          userId={userId}
          bookingId={bookingId}
        />
      </div>
    </div>
  );
}

function NavButtons({ isInsideWidget, fisheryPublicId }) {
  return (
    <div className={'user-booking-success__buttons'}>
      <Button
        id='back-btn-mobile'
        className='sb-blue-gradient-bg-right white gSemiBold brFull fs-18 txt-center w-full pd-10 h-fit txt-wrap antd-link-button-override'
        href={!isInsideWidget ? `/fishery/${fisheryPublicId}` : undefined}
        onClick={() => {
          if (isInsideWidget) {
            sendWidgetMessage({ type: 'widgetCollapse' });
          }
        }}
      >
        {isInsideWidget ? 'Close Booking Widget' : 'View Fishery Profile'}
      </Button>
      {!isInsideWidget && (
        <Button
          id='back-btn-desktop'
          className={
            'gSemiBold fs-16 txt-center w-full pd-10 h-fit txt-wrap antd-link-button-override '
          }
          type={'text'}
          href={`/fishery/${fisheryPublicId}`}
        >
          <span className={'txt-underline'}>Return to Fishery Profile</span>
        </Button>
      )}
      {!isInsideWidget && (
        <Button
          id='home-btn'
          className='bg-white border-1 sb-blue-border-500 sb-blue-500 gSemiBold brFull fs-18 txt-center w-full pd-10 h-fit txt-wrap antd-link-button-override'
          href={'/'}
        >
          Back To Home
        </Button>
      )}
    </div>
  );
}

export default function BookingSuccessScreen({
  fisheryPublicId,
  userId,
  bookingId,
  newAccountToken,
  isInsideWidget = false,
}) {
  const { data: userHasSubscription } = useGetUserHasSubscriptionQuery();

  const logo = (
    <div id='logo'>
      <div className='row-center mg-bottom-10'>
        <img className='mg-right-5' width={50} src={roundedLogo} />
        <div className='gSemiBold sb-blue fs-20 row-center'>
          swim<span className='sb-black'>booker</span>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={'user-booking-success-layout pd-20 pd-bottom-30'}
      style={{ background: '#f2f6fa' }}
    >
      {logo}
      <UserTicketSummary
        fisheryPublicId={fisheryPublicId}
        bookingId={bookingId}
        userId={userId}
      />
      {Boolean(newAccountToken) && (
        <NewAccountCard
          token={newAccountToken}
          bookingId={bookingId}
          userId={userId}
        />
      )}
      {!isInsideWidget && (
        <MarketingBrandsCard fisheryPublicId={fisheryPublicId} />
      )}
      {!isInsideWidget && !Boolean(newAccountToken) && (
        <SBPlusAdvertCard subscribed={userHasSubscription} />
      )}
      <NavButtons
        fisheryPublicId={fisheryPublicId}
        isInsideWidget={isInsideWidget}
      />
    </div>
  );
}
